import { successProbability } from "@roguelife/engine";

/**
 * Radial success-probability gauge — the web replacement for the original
 * 750-line QPainter RoundProgressBar. Same colour tiers / labels as
 * RLGame.update_round_progress, computed from the ported probability table.
 */
function tier(p: number): { color: string; label: string } {
  if (p >= 0.95) return { color: "#00cccc", label: "几乎必然成功" };
  if (p >= 0.75) return { color: "#00b300", label: "成功几率高" };
  if (p >= 0.55) return { color: "#cccc00", label: "成功几率较高" };
  if (p >= 0.35) return { color: "#ff8000", label: "成功几率中" };
  if (p >= 0.05) return { color: "#cc0000", label: "成功几率低" };
  return { color: "#990099", label: "几乎必然失败" };
}

export function SuccessGauge({
  current,
  required,
  numDice,
}: {
  current: number;
  required: number;
  numDice: number;
}) {
  const p = Math.max(0, Math.min(1, successProbability(current, required, numDice)));
  const { color, label } = tier(p);
  const size = 150;
  const stroke = 15;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  return (
    <div className="gauge">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#2a2333"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${p * c} ${c}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dasharray .5s ease, stroke .3s" }}
        />
        <text
          x="50%"
          y="48%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="26"
          fontWeight="700"
          fill={color}
        >
          {Math.round(p * 100)}%
        </text>
      </svg>
      <div className="gauge-label" style={{ color }}>
        {label}
      </div>
    </div>
  );
}
